"use client";

import { SafeUser } from '@/app/types';
import { Coffee } from 'lucide-react';
import { useSession } from 'next-auth/react';
import Head from 'next/head';
import Link from 'next/link';

interface WelcomeProps {
  currentUser?: SafeUser | null;
  subscription?: any;
}

const Welcome: React.FC<WelcomeProps> = ({ currentUser, subscription }) => {
  const { data: session } = useSession();

  return (
    <div className="bg-white text-black">
      <Head>
        <title>SEOZast - Affordable SEO Automation at €5/Month</title>
        <meta
          name="description"
          content="Your SEO shouldn’t cost more than your coffee. Analyse, find keywords, generate AI articles, deploy to GitHub or download for €5/month."
        />
      </Head>

      {/* Hero */}
      <section className="py-10 flex flex-col justify-center items-center text-center px-8 sm:px-4 sm:py-20">
        {/* <img src="/images/seozast-logo.png" alt="SEOZast logo" className="w-20 mb-4 sm:w-24" /> */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-2">SEO<span className="text-emerald-500">Zast</span></h1>
        <h2 className="text-xl sm:text-2xl md:text-3xl font-medium text-gray-800 mb-6 max-w-3xl">
          Your SEO shouldn’t cost more than your coffee
        </h2>
        <p className="text-lg sm:text-xl max-w-2xl mb-8 text-gray-600">
          Analyse, find keywords, generate AI articles, deploy to GitHub or download for €5/month.
        </p>
        <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Link
            href={currentUser ? `/dashboard/${currentUser.id}` : "/register"}
            className="inline-block bg-emerald-500 text-white font-medium py-3 px-8 rounded-md hover:bg-emerald-600 transition"
          >
            {session ? 'Go to Dashboard' : 'Try for free'}
          </Link>
          <Link
            href="/#pricing"
            className="inline-block text-emerald-500 font-medium py-3 px-8 rounded-md border border-emerald-500 hover:bg-emerald-50 transition"
          >
            See Plans
          </Link>
        </div>
        <div className="mt-6 flex items-center justify-center text-gray-500">
          <Coffee className="w-5 h-5 mr-2" />
          <span className="text-sm">Cheaper than your daily coffee!</span>
        </div>
      </section>
    </div>
  );
}

export default Welcome;